var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.pCommunity, function(communityIteration) {
        return [
          communityIteration._id !== _vm.mCommunity._id
            ? _c(
                "md-checkbox",
                {
                  key: communityIteration._id,
                  staticClass: "partner-community-checkbox",
                  attrs: {
                    name: communityIteration._id,
                    value: communityIteration._id
                  },
                  model: {
                    value: _vm.mCommunity.partnerCommunities,
                    callback: function($$v) {
                      _vm.$set(_vm.mCommunity, "partnerCommunities", $$v)
                    },
                    expression: "mCommunity.partnerCommunities"
                  }
                },
                [_vm._v(_vm._s(communityIteration.name))]
              )
            : _vm._e()
        ]
      }),
      _vm._v(" "),
      _c(
        "md-button",
        {
          staticClass: "mt-20 md-raised md-round md-accent",
          attrs: { type: "submit" }
        },
        [_vm._v("Save")]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d9a5622", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d9a5622","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PartnerCommunityList.vue
// module id = null
// module chunks = 